import { render, staticRenderFns } from "./PhonesGrid.vue?vue&type=template&id=21ef86bc&scoped=true"
import script from "./PhonesGrid.vue?vue&type=script&lang=ts"
export * from "./PhonesGrid.vue?vue&type=script&lang=ts"
import style0 from "./PhonesGrid.vue?vue&type=style&index=0&id=21ef86bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ef86bc",
  null
  
)

export default component.exports